import { useGetCertificationStatusLastChangeQuery } from 'store/certification-status-history';
import { Message } from 'semantic-ui-react';
import { useExaminerId } from './useExaminerId';

export const ExaminerCertificationWarnings = () => {
  const examinerId = useExaminerId();
  const { data: certificationStatusLastChange } = useGetCertificationStatusLastChangeQuery({
    examinerId,
  });

  return (
    <>
      {certificationStatusLastChange?.isWritingCertificationChangedManually && (
        <Message
          info
          icon="info circle"
          header="Information"
          content="Please remember that the writing status of this examiner has been set manually. Act accordingly while planning standardisation or certification."
        />
      )}

      {certificationStatusLastChange?.isSpeakingCertificationChangedManually && (
        <Message
          info
          icon="info circle"
          header="Information"
          content="Please remember that the speaking status of this examiner has been set manually. Act accordingly while planning standardisation or certification."
        />
      )}

      {certificationStatusLastChange?.isOnlineSpeakingStatusChangedManually && (
        <Message
          info
          icon="info circle"
          header="Information"
          content="Please remember that the Online Speaking status of this examiner has been set manually. Act accordingly."
        />
      )}
    </>
  );
};
